// Get all Patient Social History Status list

// PatientSocialHistoryControllerApi  getPatientSocialHistory

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PatientSocialHistoryControllerApi } from "../../../services";
import { getConfigObject, useBaseContent } from "../../../utils/utils";

interface Props {
  appointmentId: string;
  xTENANTID: string;
}

/**
 *
 * @author Atish Bagate
 *
 */
export const useGetPatientSocialHistoryByAppointmentId = ({
  appointmentId,
  xTENANTID,
}: Props): useBaseContent<any> => {
  return useQuery({
    queryKey: [
      "all-patient-social-history-by-appointment-id",
      appointmentId,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!appointmentId && !!xTENANTID,
    queryFn: async () =>
      await new PatientSocialHistoryControllerApi(getConfigObject())
        .getSocialHistoryTypesByAppointmentId(appointmentId, xTENANTID)
        .then((res) => res?.data),
  });
};
